<template>
  <CarouselSplitSection :class="backgroundClass" :carousel-list="items">
    <template #content>
      <h2 class="text-h2 mb-10 tablet:line-clamp-2">
        {{ title }}
      </h2>
      <TheRichText
        v-if="descriptionHtml || description"
        class="mb-10 w-full text-sm leading-6 text-gray-700 tablet:line-clamp-7 tablet:text-base"
        :text="descriptionHtml || description"
        :is-html="!!descriptionHtml"
      />
    </template>

    <template #card="{ item }">
      <CardLogo02
        :title="item.name"
        :description="item.description"
        :image-url="item.thumbnail"
        :logos="item.logos"
        :tag="item.tag"
        :button-name="item.linkName"
        :button-id="item.trackingCode"
        :button-url="item.link"
        :video-url="item.wistiaCode"
        :clickable="true"
        :has-shadow="false"
      />
    </template>
  </CarouselSplitSection>
</template>

<script setup lang="ts">
  /**
   * @see https://www.figma.com/design/QJ3ZvEbUHI9xI11iudYf8U/Advantech-WISE-Library?node-id=13367-41281&t=89PIFDiQEC4zcSbf-0
   */

  interface IItem {
    name: string;
    description: string;
    link: string;
    linkName: string;
    thumbnail: string;
    wistiaCode?: string;
    trackingCode?: string;
    logos: string[];
    tag?: string;
  }

  interface IProps {
    title: string;
    description?: string;
    descriptionHtml?: string;
    items: IItem[];
    theme?: TTheme;
  }

  const props = withDefaults(defineProps<IProps>(), {
    description: undefined,
    descriptionHtml: undefined,
    theme: 'blue',
  });

  const backgroundClass = computed((): string => {
    switch (props.theme) {
      case 'green':
        return 'bg-gradient-to-t from-green-150 to-white';
      case 'cyan':
        return 'bg-gradient-to-t from-cyan-150 to-white';
      case 'purple':
        return 'bg-gradient-to-t from-purple-150 to-white';
      case 'yellow':
        return 'bg-gradient-to-t from-yellow-150 to-white';
      default:
        return 'bg-gradient-to-t from-blue-150 to-white';
    }
  });

  export type { IItem };
</script>
